import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatJson' })
export class FormatJsonPipe implements PipeTransform {
    transform(value, exponent): string {
        var returnVal = "";

        if(value == null || value == undefined || !Object.keys(value).length)
            return "-";
        else{
            for (var key in value) {
                if (value.hasOwnProperty(key)) {
                    if(typeof value[key] === 'object'){
                        var innerVal = value[key];
                        if(innerVal instanceof Array){
                            //console.log("x");
                            returnVal += key + "\n";
                            for(var cnt = 0; cnt<innerVal.length; cnt++){
                                returnVal += "[" + (cnt+1).toString() + "]\n";

                                var innerArrayItem = innerVal[cnt];

                                for (var innerKey in innerArrayItem ) {
                                    returnVal += "- " + innerKey + " : " + innerArrayItem[innerKey] + "\n";
                                }

                                returnVal += "\n";
                            }
                        }
                        else if(innerVal instanceof Object){
                            //console.log("y");
                            returnVal += key + ":\n";//Properties
                            for (const i_item of Object.keys(innerVal)) {
                                if (innerVal.hasOwnProperty(i_item)) 
                                {
                                    console.log(typeof innerVal[i_item]);

                                    if(typeof innerVal[i_item] === 'object')
                                    {
                                        var innerInnerVal = innerVal[i_item];
                                        if(innerInnerVal instanceof Array){
                                            console.log("x2");
                                            returnVal += i_item + "\n";
                                            for(var cnt2 = 0; cnt2<innerInnerVal.length; cnt2++){
                                                returnVal += "[" + (cnt2+1).toString() + "]\n";

                                                var innerInnerArrayItem = innerInnerVal[cnt2];

                                                for (var innerInnerKey in innerInnerArrayItem ) {
                                                    returnVal += "- " + innerInnerKey + " : " + innerInnerArrayItem[innerInnerKey] + "\n";
                                                }

                                                returnVal += "\n";
                                            }
                                        }
                                        else{
                                            returnVal += "~ " + i_item + " :\n";
                                            for (var xxkey in innerVal[i_item]) {
                                                returnVal += "\t" + xxkey + " : " + innerVal[i_item][xxkey]+ "\n";
                                            }
                                        }
                                    }
                                    else{
                                        returnVal += "~ " + i_item + " : " + innerVal[i_item] + "\n";
                                    }
                                }
                            }
                        }
                        else{
                            returnVal += key + "\n";
                            for (var innerKey in innerVal ) {
                                returnVal += "- " + innerKey + " : " + innerVal[innerKey] + "\n";
                            }
                        }
                    }
                    else
                        returnVal += key + " : " + value[key] + "\n";
                }
            }
            return returnVal;
        }
    }

}